/* global axios */
import ApiClient from './ApiClient';

class QuickActionsAPI extends ApiClient {
  constructor() {
    super('quick_actions', { accountScoped: true });
  }

  execute(id, payload) {
    return axios.post(`${this.url}/${id}/execute`, payload);
  }
}

export default new QuickActionsAPI();
